const Testimonials = (testimonials) => {
    const view = testimonials.posts
      .map((testimonial) => {
        return `
        <div class="testimonial entry-content">
            <blockquote>
                <q>
                    ${testimonial['testimonial-content']}
                </q>
                <cite>
                    - ${testimonial['testimonial-client']}
                </cite>
            </blockquote>

        </div>
          `;
      })
      .join('');
    return view;
  };
  
  export default Testimonials;